import React, { useState } from 'react';
import './Categories.css';

const Categories = ({ onNavigate }) => {
    const [selectedCategory, setSelectedCategory] = useState(null);

    const categories = [
        {
            id: 'professional-services',
            name: 'Professional Services',
            image: 'https://images.unsplash.com/photo-1664575602554-2087b04935a5?w=400&h=400&fit=crop',
            description: "Comprehensive professional services tailored to meet the unique demands of businesses across every sector. From consulting and logistics to procurement and supply chain management, we deliver end-to-end solutions with a focus on reliability, efficiency, and excellence. Our team of experienced professionals works closely with clients to understand their needs and provide customised service packages that drive growth and operational success."
        },
        {
            id: 'visa-pro-services',
            name: 'Visa & PRO Services',
            image: 'https://media.licdn.com/dms/image/v2/D4D12AQGkdCNCXeycAQ/article-cover_image-shrink_720_1280/article-cover_image-shrink_720_1280/0/1722964894211?e=1786579200&v=beta&t=sxsbK00sLyvshRVipHfJzw76Q6FMnqM1HQaBqlHK9pI',
            description: "Seamless visa and PRO services for hassle-free business success across the UAE. We handle employment visas, investor and partner visas, family sponsorships, trade license processing, document attestation, and government approvals with expert precision. Our team stays on top of renewals and cancellations, ensuring full compliance with UAE regulations while saving you time, effort, and cost. From initial application to final approval, we provide end-to-end support so you can focus on growing your business."
        },
        {
            id: 'ecommerce',
            name: 'E-Commerce',
            image: 'https://images.unsplash.com/photo-1664455340023-214c33a9d0bd?q=80&w=2832&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D?fit=crop',
            description: "Seamless e-commerce solutions designed to connect businesses with customers efficiently and effectively. We support retailers and suppliers with everything needed to thrive in the digital marketplace, from product listings and inventory management to fulfilment and last-mile delivery. Our platform enables smooth, secure transactions and a superior shopping experience for both businesses and end consumers."
        },
        {
            id: 'hospitality-essentials',
            name: 'Hospitality Essentials',
            image: 'https://i.pinimg.com/736x/52/ca/13/52ca130663f78628aa7d9ebe263c1fde.jpg?w=400&h=400&fit=crop',
            description: "Premium hospitality supplies for hotels, resorts, and guest accommodations. Our hospitality essentials collection includes luxury towels, bed linens, bathrobes, toiletries, and guest amenities that elevate the overall experience. From soft Egyptian cotton towels to plush bedding and professional-grade bathroom accessories, we provide everything needed to maintain five-star standards and ensure lasting guest comfort and satisfaction."
        },
        {
            id: 'food-provisions',
            name: 'Food & Provisions',
            image: 'https://images.unsplash.com/photo-1708436477874-f6d1743504bc?q=80&w=987&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D?fit=crop',
            description: "Stock your pantry and supply your kitchen with our premium selection of food and provisions. From protein-rich pulses and lentils to wholesome grains like rice, wheat, and quinoa, we source only the finest quality products from trusted suppliers. Our range also includes everyday staples and specialty ingredients that form the foundation of nutritious, flavourful meals across diverse cuisines and dietary preferences."
        },
        {
            id: 'cleaning-hygiene',
            name: 'Cleaning & Hygiene Solutions',
            image: 'https://images.unsplash.com/photo-1626379481874-3dc5678fa8ca?q=80&w=2340&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D?fit=crop',
            description: "Maintain the highest standards of cleanliness and hygiene with our professional-grade cleaning and sanitation products. Designed for use in commercial, hospitality, and healthcare environments, our range includes surface disinfectants, industrial cleaners, personal hygiene products, and eco-friendly solutions. We prioritise safety, effectiveness, and sustainability to help your business meet regulatory standards and create clean, healthy spaces."
        },
        {
            id: 'tableware-kitchenware',
            name: 'Tableware & Kitchenware',
            image: 'https://i.pinimg.com/1200x/8e/d5/62/8ed562617ef7ce95fa6a822cf2854e13.jpg?fit=crop',
            description: "Complete your kitchen and dining setup with our extensive collection of quality tableware and kitchenware. From elegant dinner plates and serving dishes to professional-grade cutlery, glassware, and cooking tools, we offer everything you need for both everyday service and special occasions. Our selection combines durability, functionality, and aesthetic appeal to enhance your culinary experience and elevate every dining presentation."
        },
        {
            id: 'furniture',
            name: 'Furniture',
            image: 'https://i.pinimg.com/736x/ef/af/ac/efafaceab9e3d7770bb4918ccef67baf.jpg?w=400&h=400&fit=crop',
            description: "Transform your space with our curated furniture collection designed for comfort, style, and longevity. Whether furnishing a hotel, office, restaurant, or home, we offer a diverse range of sofas, tables, chairs, storage solutions, and bedroom sets. Each piece is crafted with attention to detail, combining modern aesthetics with practical functionality to create beautiful, functional spaces that leave a lasting impression on every guest and visitor."
        }
    ];

    const openModal = (category) => {
        if (category.id === 'visa-pro-services') {
            onNavigate('visa-pro-services');
            return;
        }
        setSelectedCategory(category);
        document.body.style.overflow = 'hidden';
    };

    const closeModal = () => {
        setSelectedCategory(null);
        document.body.style.overflow = '';
    };

    const handleOverlayClick = (e) => {
        if (e.target.classList.contains('modal-overlay')) {
            closeModal();
        }
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Escape' && selectedCategory) {
            closeModal();
        }
    };

    React.useEffect(() => {
        document.addEventListener('keydown', handleKeyDown);
        return () => document.removeEventListener('keydown', handleKeyDown);
    }, [selectedCategory]);

    return (
        <>
            <section className="section" id="categories">
                <div className="container">
                    <div className="section-header">
                        <h2 className="section-title">Explore Our Categories</h2>
                        <p className="section-subtitle">Find exactly what you're looking for across our diverse range</p>
                    </div>

                    <div className="categories-grid">
                        {categories.map((category, index) => (
                            <div
                                key={category.id}
                                className="category-card"
                                data-category={category.id}
                                onClick={() => openModal(category)}
                                style={{ animationDelay: `${index * 100}ms` }}
                            >
                                <div className="category-image-wrapper">
                                    <img
                                        src={category.image}
                                        alt={category.name}
                                        className="category-image"
                                    />
                                </div>
                                <h3 className="category-name">{category.name}</h3>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* Modal */}
            {selectedCategory && (
                <div className="modal-overlay active" onClick={handleOverlayClick}>
                    <div className="modal">
                        <button className="modal-close" onClick={closeModal} aria-label="Close modal">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                <line x1="18" y1="6" x2="6" y2="18"/>
                                <line x1="6" y1="6" x2="18" y2="18"/>
                            </svg>
                        </button>

                        <div className="modal-body">
                            <img
                                src={selectedCategory.image}
                                alt={selectedCategory.name}
                                className="modal-image"
                            />
                            <div className="modal-content">
                                <h2 className="modal-header">{selectedCategory.name}</h2>
                                <p className="modal-text">{selectedCategory.description}</p>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default Categories;